import React from "react";

export function AuthShell({ title, subtitle, children }) {
  return (
    <div className="flex min-h-[85vh] flex-col justify-center px-6 py-10">
      <div className="mb-6">
        <div className="mb-4 flex items-center gap-2">
          <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-white border border-slate-200 shadow-sm">
            <svg viewBox="0 0 48 24" className="h-5 w-5" fill="none">
              <path d="M8 12a6 6 0 1 1 12 0 6 6 0 1 1-12 0Z" stroke="#F26A21" strokeWidth="3" />
              <path d="M28 12a6 6 0 1 1 12 0 6 6 0 1 1-12 0Z" stroke="#0E1C3A" strokeWidth="3" />
            </svg>
          </div>
          <div className="font-heading text-xl font-extrabold"><span className="text-medorange">Med</span><span className="text-navy">Lync</span></div>
        </div>
        <h1 className="font-heading text-2xl font-extrabold text-slate-900">{title}</h1>
        <p className="mt-1 text-sm text-slate-500">{subtitle}</p>
      </div>
      <div className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">{children}</div>
    </div>
  );
}
